export default {"src":"/_next/static/media/directionsIcon.3d5d9d51.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};